/**
 * SIM-SZENE LEIPZIG – StartScreen
 * Titelbildschirm mit Neues Spiel / Fortsetzen.
 */
import { hasSavedGame, clearGameState } from '../state/gameState.jsx';
import './StartScreen.css';

export function StartScreen({ onStart, onContinue }) {
  const savedGame = hasSavedGame();
  
  const handleNewGame = () => {
    clearGameState();
    onStart();
  };
  
  return (
    <div className="start-screen">
      {/* Hintergrund im American-Dream-Stil */}
      <div className="start-background">
        <div className="stars-bg animated"></div>
      </div>
      
      {/* Titel */}
      <div className="start-content">
        <h1 className="start-title">
          <span className="title-main">SIM-SZENE</span>
          <span className="title-city">LEIPZIG</span>
        </h1>
        
        <p className="start-subtitle">Operation Überleben</p>
        
        {/* Beschreibung */}
        <div className="start-description">
          <p>
            Du bist Clubbetreiber*in in Leipzig. 
            Jongliere Geld, Nerven und Credibility – 
            und versuche, nicht unterzugehen.
          </p>
          <p className="start-warning">
            ⚠️ Es gibt kein Happy End.
          </p>
        </div>
        
        {/* Buttons */}
        <div className="start-buttons">
          {savedGame && (
            <button 
              className="button-continue"
              onClick={onContinue}
            >
              Fortsetzen
            </button>
          )}
          <button 
            className="button-new"
            onClick={handleNewGame}
          >
            {savedGame ? 'Neues Spiel' : 'Spiel starten'}
          </button>
        </div>
      </div>
    </div>
  );
}
